module.exports = __webpack_public_path__ + "media/static/logoDevbot-blue-74f742b711524c959276a161a3eb7b64.png";